import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { trackCloseOfferMap, trackOpenOfferMap } from './tracking';
import { getGeoData } from './utils/getGeoData';
import { useOfferContext } from '../../../../context';
import { useYmaps } from '../../../../hooks';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';
import { MapModal } from 'shared/components/MapModal/MapModal';

interface IProps {
  isHovered: boolean;
}

export const ShowOnMapControlContainer = ({ isHovered }: IProps) => {
  const [isMapOpen, setIsMapOpen] = React.useState<boolean>(false);

  const { offer, position } = useOfferContext();

  const handleOpenMap = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setIsMapOpen(true);
      trackOpenOfferMap(offer.id ?? undefined, position);
    },
    [offer.id, position],
  );

  const handleCloseMap = React.useCallback(() => {
    setIsMapOpen(false);
    trackCloseOfferMap(offer.id ?? undefined, position);
  }, [offer.id, position]);

  const coordinates = React.useMemo(() => getGeoData(offer.geo ?? undefined), [offer.geo]);

  const yMapsContainer = useYmaps({ isOpen: isMapOpen, coordinates, isFavorite: Boolean(offer.isFavorite) });

  return coordinates ? (
    <ControlWrapper visible={isHovered}>
      <TooltipDesktop theme="black" placement="left" title="Показать на карте">
        <Button
          data-mark="ShowOfferOnMapControl"
          theme="stroke_secondary"
          onClick={handleOpenMap}
          size="XS"
          beforeIcon={<IconMapPin16 />}
        />
      </TooltipDesktop>
      <MapModal ref={yMapsContainer} isOpen={isMapOpen} onClose={handleCloseMap} />
    </ControlWrapper>
  ) : null;
};
